// MARK://dhk8/admin-shell/components/ShareLinkButton
// Botón "Copiar enlace" para superficies públicas del comensal (cola, reservas).
// El comerciante no tenía forma de recuperar/compartir el enlace público de su
// negocio desde el admin — solo veía el dominio genérico (queue.nintaigo.com).
//
// El enlace correcto lleva el slug/tenant de la cuenta:
//   - Cola:     https://queue.nintaigo.com/queue/<slug>
//   - Reservas: https://reservar.nintaigo.com/reservar/<liveTenantId>   (reservar
//               aún resuelve por UUID; migrar a slug es pulido pendiente)
// Siempre apunta al entorno EN VIVO (lo que el negocio comparte con clientes reales).

import { useState } from 'react'
import { Link2, Check, ExternalLink } from 'lucide-react'
import { useAuthStore } from '../stores/auth-store.js'

interface ShareLinkButtonProps {
  /** Construye la URL pública a partir de slug + liveTenantId. Devuelve null si
   *  faltan datos (cuenta sin slug) → el botón se deshabilita con motivo. */
  buildUrl: (ctx: { slug: string | null; liveTenantId: string | null }) => string | null
  label?: string
}

export function ShareLinkButton({ buildUrl, label = 'Copiar enlace' }: ShareLinkButtonProps) {
  const session = useAuthStore((s) => s.session)
  const [copied, setCopied] = useState(false)
  const url = buildUrl({ slug: session?.slug ?? null, liveTenantId: session?.liveTenantId ?? null })

  async function copy(): Promise<void> {
    if (!url) return
    try {
      if (typeof navigator !== 'undefined' && navigator.clipboard) {
        await navigator.clipboard.writeText(url)
        setCopied(true)
        setTimeout(() => setCopied(false), 2500)
      }
    } catch { /* sin ruido */ }
  }

  return (
    <span style={{ display: 'inline-flex', gap: 6 }}>
      <button
        type="button"
        className="adm-btn"
        onClick={copy}
        disabled={!url}
        title={url ?? 'La cuenta aún no tiene slug público'}
      >
        {copied ? <Check size={14} /> : <Link2 size={14} />} {copied ? 'Copiado' : label}
      </button>
      {url && (
        <a className="adm-btn" href={url} target="_blank" rel="noreferrer" title={`Abrir ${url}`}>
          <ExternalLink size={14} />
        </a>
      )}
    </span>
  )
}
